import React, { Component } from 'react'; //different
import { t } from './site/i18n';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
// import './style.css';
import Main from './main';
import Casino from './casino';
import NavMenu from './navmenu';
import Slot from './slot';
import Arcade from './arcade';
import Sport from './sport';
import Fising from './fising';
import Promotion from './promotion';
import Login from './login';
import Logout from './logout';
import Linklistall from './linklistall';
import Linklistalldemo from './linklistaldemo';
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import SweetAlert from 'react-bootstrap-sweetalert';
import jwt_decode from "jwt-decode";
import Swal from 'sweetalert2'
import Freegame from './slotfree';
import Register from './register';
import RegisterForm from './RegisterForm';
import io from "socket.io-client";
import moment from 'moment';
import Spinwheels from './spinweel';
import $ from "jquery";
import Paoyingchub from './game/paoyingchub';
import { Flag } from '@mui/icons-material';
import md5 from 'md5';
import { siteRoutes } from './site/routes';

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mainsetting: [],
      rewardlist: [],
      activePage: 1,
      checkboxcookie: false,
      isActive: false,
      formData: {}, // Contains login form data
      errors: {}, // Contains login field errors
      formSubmitted: false, // Indicates submit status of login form
      loading: true, // Indicates in progress state of login form
      pagecount: 1,
      username: null,
      settingwheel: "",
      settingcheckin: "",
      userid: null,
      phoneNumber: "",
      balance: 0,
      mainacc: null,
      qrcode: null,
      stateregis: 1,
      checkboxacc: 0,
      products_page_count: 1,
      loginstate: false,
      fullname: null,
      lname: null,
      link: "",
      alert: null,
      depositstate: 0,
      stateforget: 1,
      depositamount: 0,
      stateopterror: "",
      btnisActive: true,
      otpphone: "",
      token: window.localStorage.getItem("token"),
      accnumber: null,
      accnumbertxt: null,
      withdrawamount: 0,
      rankpoint: 0,
      changepassword: false,
      linelink: "",
      errortext: "",
      trueaccount: null,
      datas: null,
      otpphoneforget: "",
      affpercent: 0,
      userrecomend: "",
      historylist: [],
      useradvice: [],
      cashoutlist: [],
      tblnextrank: [],
      tblrankall: [],
      maxwithdrawstatus: 0,
      tblprofile: [],
      prodetail: [],
      oldpassword: "",
      linkaff: "",
      webnamex: "",
      inviteSet: "",
      truegiftlink: "",
      proderedeem: [],
      proderedeemlist: [],
      buttoncliam: false,
      limit: null,
      rankpic: "1.jpeg",
      rankname: null,
      rankob: null,
      cashoutSet: [],
      tblPopupMenu1: [],
      tblPopupMenu2: [],
      tblPopupMenu: null,
      termAndCondition: false,
      errorstatus: false,
    }
    this.handleClick = this.handleClick.bind(this);
    this.forgetotpandregister = this.forgetotpandregister.bind(this);
  }
  copyCode = () => {
    navigator.clipboard
      .writeText(this.state.linkaff)
      .then(() => {
        setTimeout(function () {
        }, 3000);
      })
      .catch((err) => {
        // console.log(err.message);
      });
  };

  openAccout(evt, cityName) {
    // var i, tabcontent, tablinks;
    // tabcontent = document.getElementsByClassName("js-profile-account-modal");
    // for (i = 0; i < tabcontent.length; i++) {
    //   tabcontent[i].style.display = "none";
    // }
    // tablinks = document.getElementsByClassName("tabaccount");
    // for (i = 0; i < tablinks.length; i++) {
    //   tablinks[i].className = tablinks[i].className.replace(" active", "");
    // }
    // document.getElementById(cityName).style.display = "block";
    // evt.currentTarget.className += " active";
  }
  showClockRealTime = (datestart) => {
    // var days = ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัส', 'ศุกร์', 'เสาร์'];

    var months_th_mini = t('app.months_short').split(',');
    var today = new Date(datestart);
    var endday = months_th_mini[today.getMonth()];

    return endday;
  }
  handleClick = async (e, price) => {
    if (price <= this.state.balance) {
      this.setState({
        withdrawamount: price
      });
    }
    else {
      await Swal.fire({
        title: t('common.warning'),
        text: t('app.insufficient_withdraw'),
        icon: 'warning',
        confirmButtonText: t('common.ok')
      })
    }
  }

  getpopup = () => {
    //  var token = localStorage.getItem('auth_token');
    //  if()
    // var decoded = jwt_decode(token);
    //  var Username = decoded.message.playerid;
    instance.post("/api/v1/popuplist", {
      System: Systems,
      Cat_ID: 0,
      page: 1,
      type: 1
    }).then(async (res) => {
      if (res.data.status === 200) {
        console.log(160, res.data.message.banklist);
        this.setState({
          tblPopupMenu1: res.data.message.tblPopupMenu1,
          tblPopupMenu: res.data.message.banklist,
          tblPopupMenu2: res.data.message.tblPopupMenu2,
        });



      }
    }).catch(async (err) => {
      // console.log(err);
      if (err.response.status === 401 || err.response.status === 403) {
        localStorage.clear();
        await Swal.fire({
          title: t('common.warning'),
          text: t('common.session_expired'),
          icon: 'warning',
          confirmButtonText: t('common.ok')
        })
        window.location.href = '/';
      }
    });

  }
  checkpro = async (e, proid) => {
    var token = localStorage.getItem('auth_token');
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;
    await instance.post("/api/v1/checkpromotion", {
      userid: Username,
      System: Systems,
      Proid: proid,
    }, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(async (res) => {
      if (res.data.status === 200) {
        console.log(209, res.data);
        if (res.data.type === 0) {
          this.setState({
            prodetail: res.data.message.tblpromotions[0],
          });
        }
        else if (res.data.type === 1) {
          this.setState({
            proderedeem: res.data.message.tblpromotionredeems,
            proderedeemlist: res.data.message.tblpromotionredeems,
          });
        }

      }
      else if (res.data.status === 201) {
        this.setState({
          prodetail: [],
          picnonpro: "/media/cache/strip/202109/promotion/7AB3F352-6DE2-44CC-A5FC-D4359FCB2122.png",
        });

      }
      else if (res.data.status === 202) {
        await Swal.fire({
          title: t('common.error'),
          text: t('common.promo_active'),
          icon: 'error',
          confirmButtonText: t('common.ok')
        })
        return false;
      }

    }).catch(async (err) => {
      // console.log(err);
      if (err.response.status === 401 || err.response.status === 403) {
        localStorage.clear();
        await Swal.fire({
          title: t('common.warning'),
          text: t('common.session_expired'),
          icon: 'warning',
          confirmButtonText: t('common.ok')
        })
        window.location.href = '/';
      }
    });
  }

  redeempro = async (e, proid) => {
    e.preventDefault();
    var token = localStorage.getItem('auth_token');
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;
    // console.log(Username, proid);
    await instance.post("/api/v1/redeempromotion", {
      userid: Username,
      System: Systems,
      Proid: proid,
    }, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(async (res) => {
      //  console.log(res.data.status)
      if (res.data.status === 200) {
        document.getElementById("opendeposit").click()
        // await Swal.fire({
        //   title: 'success!',
        //   text: 'm',
        //   icon: 'success',
        //   confirmButtonText: 'သဘောတူသည်။'
        // })
      }
      else if (res.data.status === 201) {
        await Swal.fire({
          title: t('common.error'),
          text: t('common.promo_not_eligible'),
          icon: 'error',
          confirmButtonText: t('common.ok')
        })
        e.preventDefault();
        return false;
      }
      else if (res.data.status === 204) {
        await Swal.fire({
          title: t('common.error'),
          text: t('app.daily_limit_reached'),
          icon: 'error',
          confirmButtonText: t('common.ok')
        })
        e.preventDefault();
        return false;
      }
      else if (res.data.status === 202) {
        await Swal.fire({
          title: t('common.error'),
          text: t('app.promo_already_used'),
          icon: 'error',
          confirmButtonText: t('common.ok')
        })
        e.preventDefault();
        return false;
      }

    }).catch(async (err) => {
      // console.log(err);
      if (err.response.status === 401 || err.response.status === 403) {
        localStorage.clear();
        await Swal.fire({
          title: t('common.warning'),
          text: t('common.session_expired'),
          icon: 'warning',
          confirmButtonText: t('common.ok')
        })
        window.location.href = '/';
      }
    });
  }

  async recheccredit(evt) {

    evt.currentTarget.className += " fa-spin";
    var token = localStorage.getItem('auth_token');
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;
    //this.rechecklogin(Username, token);
    this.setState({
      userid: decoded.message.playerid,
      username: decoded.message.playerid,
      firstname: decoded.message.firstname,
      lastname: decoded.message.lastname,
      loginstate: true,
    });
    try {
      // console.log(2);
      await instance.post("/api/v1/checkpoint", {
        userid: Username,
        System: Systems,
        Function: 'recheccredit-App.js'
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(async (res) => {
        if (res.data.status === 200) {
          console.log(res.data.message.accnumber);
          localStorage.setItem('auth_token', res.data.token)
          this.setState({
            accnumber: res.data.message.accnumber,
            userid: res.data.message.member_id,
            username: res.data.message.playerid,
            fullname: res.data.message.firstname,
            point: res.data.message.Point,
            balance: res.data.databalance,
            loginstate: true,
          });
          var i, tablinks;
          tablinks = document.getElementsByClassName("btn btn-link -reload-btn p-0");
          for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" fa-spin", "");
          }
        }
        else if (res.data.status === 401) {
          //   console.log(res.data);
          localStorage.clear();
          await Swal.fire({
            title: t('common.warning'),
            text: t('common.session_expired'),
            icon: 'warning',
            confirmButtonText: t('common.ok')
          })
          window.location.href = '/';
        }

      }).catch(async (err) => {
        // console.log(err);
        if (err.response.status === 401 || err.response.status === 403) {
          localStorage.clear();
          await Swal.fire({
            title: t('common.warning'),
            text: t('common.session_expired'),
            icon: 'warning',
            confirmButtonText: t('common.ok')
          })
          window.location.href = '/';
        }
      });
    }
    catch (ex) {
      ////////console.log(ex);
    }
  }

  handleClickdeposit = async (e, price) => {
    this.setState({
      depositamount: price

    });
  }
  onChangexdep = event => {
    ////console.log(event.target.value);
    if (event.target !== undefined) {

      this.setState({ depositamount: event.target.value });
    }
  };

  onChangexgiftlink = event => {
    ////console.log(event.target.value);
    if (event.target !== undefined) {

      this.setState({ truegiftlink: event.target.value });
    }
  };

  checkpromotions = async (e, num) => {
    e.preventDefault();
  }


  confirmdeposittrue = async (e, num) => {
    e.preventDefault();

    var token = localStorage.getItem('auth_token');
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;
    if (token !== null && this.state.btnisActive === true) {
      if (this.state.truegiftlink !== "") {
        this.setState({ statetrue: t('common.processing'), btnisActive: false });
        Username = decoded.message.playerid;
        await instance.post("/api/v1/redeemtrue", {
          userid: Username,
          System: Systems,
          link: this.state.truegiftlink
        }, {
          headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
          if (res.data.status === 200) {
            console.log(res.data.amountx);
            this.setState({ btnisActive: true, statetrue: t('app.gift_link_hint') });
            await Swal.fire({
              title: t('common.success'),
              text: t('app.topup_success').replace('{amount}', res.data.amountx),
              icon: 'success',
              confirmButtonText: t('common.ok')
            })
          }
          else if (res.data.status === 202) {
            this.setState({ btnisActive: true, statetrue: t('app.gift_link_hint') });
            await Swal.fire({
              title: t('common.warning'),
              text: t('app.gift_link_used'),
              icon: 'warning',
              confirmButtonText: t('common.ok')
            })
          }
          else if (res.data.status === 203) {
            this.setState({ btnisActive: true, statetrue: t('app.gift_link_hint') });
            await Swal.fire({
              title: t('common.warning'),
              text: t('app.gift_link_wrong_account'),
              icon: 'warning',
              confirmButtonText: t('common.ok')
            })
          }
          else if (res.data.status === 205) {
            this.setState({ btnisActive: true, statetrue: t('app.gift_link_hint') });
            await Swal.fire({
              title: t('common.warning'),
              text: t('app.truemoney_closed'),
              icon: 'warning',
              confirmButtonText: t('common.ok')
            })
          }
          else {
            this.setState({ btnisActive: true, statetrue: t('app.gift_link_hint') });
            await Swal.fire({
              title: t('common.warning'),
              text: t('app.gift_link_failed'),
              icon: 'warning',
              confirmButtonText: t('common.ok')
            })
          }
        });
      }
      else if (this.state.truegiftlink === "") {
        await Swal.fire({
          title: t('common.warning'),
          text: t('app.gift_link_missing'),
          icon: 'warning',
          confirmButtonText: t('common.ok')
        })
      }
    }
    else {
      await Swal.fire({
        title: t('common.warning'),
        text: t('common.processing'),
        icon: 'warning',
        confirmButtonText: t('common.ok')
      })
    }
  }
  confirmdeposit = async (e, num) => {
    // console.log(493,num)
    e.preventDefault();
    var token = localStorage.getItem('auth_token');
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;
    if (token !== null) {
      await instance.post("/api/v1/getredeempromotion", {
        userid: Username,
        System: Systems,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(async (res) => {
        if (res.data.status === 200) {
          this.setState({
            proderedeem: res.data.message.tblpromotionredeems,
          });

        }
      }).catch(async (err) => {
      });
    }

    if (num === 0) {
      if ((this.state.depositamount >= this.state.limit.min) && (this.state.depositamount <= this.state.limit.max)) {
        const { depositstate } = this.state
        //////console.log(depositstate, num);
        if (num === 0) {
          if (token !== null) {
            Username = decoded.message.playerid;
            instance.post("/api/v1/getqrcode", {
              username: Username,
              System: Systems,
              amount: this.state.depositamount
            }, {
              headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
              //////console.log(res.data.picture)
              this.setState({
                mainacc: res.data.mainacc,
                qrcode: res.data.picture
              });
            });
          }

          this.setState({
            depositstate: 1
          });
        }
      }
      else {
        await Swal.fire({
          title: t('common.warning'),
          text: t('common.deposit_limit').replace('{min}', this.state.limit.min).replace('{max}', this.state.limit.max),
          icon: 'warning',
          confirmButtonText: t('common.ok')
        })
      }
    }
    else if (num === 1) {
      this.setState({
        depositstate: 1
      });
    }

    else if (num === 5) {
      document.getElementById("truemonney").click()
      //deposittruemoneyModal
    }
    else {
      this.setState({
        depositstate: 0
      });
    }



  }

  redeemrank = async (e, index) => {
    e.preventDefault();
    //console.log(index);

    var token = localStorage.getItem('auth_token');
    if (token !== null) {
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      Swal.fire({
        icon: 'warning',
        title: t('app.confirm_claim_rank'),
        showCancelButton: true,
        confirmButtonText: t('common.confirm'),
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          await instance.post("/api/v1/userredeemrank", {
            User_id: Username,
            rankno: index.no,
            System: Systems,
            amount: index.claimamount
          }, {
            headers: { Authorization: `Bearer ${token}` }
          }).then(async (res) => {
            if (res.data.status === 200) {
              const datas = res.data.message;
              this.calllisthistory(Username);
              this.checklogin();
              Swal.fire(t('common.done'), '', 'success')
            }
            else {
              Swal.fire(t('common.try_later'), '', 'error')
            }
          });

        }
      })
    }

  }
  async opencliamcashout(evt, cityName) {
    var token = localStorage.getItem('auth_token');
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;
    await instance.post("/api/v1/cliamcashout", {
      userid: Username,
      System: Systems,
    }, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(async (res) => {
      if (res.data.status === 200) {
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        this.rechecklogin(Username, token);
        await Swal.fire({
          title: t('common.success'),
          text: t('app.claim_success'),
          icon: 'success',
          confirmButtonText: t('common.ok')
        })

      }
      else if (res.data.status === 201) {
        await Swal.fire({
          title: t('common.error'),
          text: t('app.no_balance_to_claim'),
          icon: 'error',
          confirmButtonText: t('common.ok')
        })
        return false;
      }
      else if (res.data.status === 202) {
        await Swal.fire({
          title: t('common.error'),
          text: t('app.cannot_process'),
          icon: 'error',
          confirmButtonText: t('common.ok')
        })
        return false;
      }

    }).catch(async (err) => {
      // console.log(err);
      if (err.response.status === 401 || err.response.status === 403) {
        localStorage.clear();
        await Swal.fire({
          title: t('common.warning'),
          text: t('common.session_expired'),
          icon: 'warning',
          confirmButtonText: t('common.ok')
        })
        window.location.href = '/';
      }
    });
  }

  resetpassword = async (e, type) => {
    e.preventDefault();
    const { phoneNumber, fname, password, oldpassword, passwordcf, checkboxacc, accnumbertxt } = this.state;
    console.log(type, password, oldpassword, passwordcf);
    var token = localStorage.getItem('auth_token');
    if (password === passwordcf) {
      var Username = null;
      var decoded = null;
      if (type === 1 && token !== null) {
        decoded = jwt_decode(token);
        Username = decoded.message.playerid;
        instance.post("/api/v1/resetpassword", {
          username: Username,
          oldpass: oldpassword,
          System: Systems,
          newpass: password,
          type: type
        }, {
          headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
          if (res.data.status === 200) {
            await Swal.fire({
              title: t('common.success'),
              text: t('app.password_changed'),
              icon: 'Success',
              confirmButtonText: t('common.ok')
            })
          }
          else if (res.data.status === 201) {
            await Swal.fire({
              title: t('common.error'),
              text: t('app.old_password_wrong'),
              icon: 'error',
              confirmButtonText: t('common.ok')
            })
          }
          else if (res.data.status === 203) {
            await Swal.fire({
              title: t('common.error'),
              text: t('app.error_try_again'),
              icon: 'error',
              confirmButtonText: t('common.ok')
            })
          }
          else if (res.data.status === 202) {
            await Swal.fire({
              title: t('common.error'),
              text: t('app.same_password'),
              icon: 'error',
              confirmButtonText: t('common.ok')
            })
          }
        });
      }
      else if (type === 2) {
        instance.post("/api/v1/resetpassword", {
          username: phoneNumber,
          oldpass: oldpassword,
          newpass: password,
          System: Systems,
          type: type
        }).then(async (res) => {
          if (res.data.status === 200) {
            await Swal.fire({
              title: t('common.success'),
              text: t('app.password_changed'),
              icon: 'success',
              confirmButtonText: t('common.ok')
            })
          }
          else if (res.data.status === 201) {
            await Swal.fire({
              title: t('common.error'),
              text: t('app.old_password_wrong'),
              icon: 'error',
              confirmButtonText: t('common.ok')
            })
          }
          else if (res.data.status === 203) {
            await Swal.fire({
              title: t('common.error'),
              text: t('app.error_try_again'),
              icon: 'error',
              confirmButtonText: t('common.ok')
            })
          }
          else if (res.data.status === 202) {
            await Swal.fire({
              title: t('common.error'),
              text: t('app.same_password'),
              icon: 'error',
              confirmButtonText: t('common.ok')
            })
          }
        });
      }
      else if (type === 3) {
        instance.post("/api/v1/resetpassword", {
          username: phoneNumber,
          oldpass: oldpassword,
          newpass: password,
          System: Systems,
          type: type
        }).then(async (res) => {
          if (res.data.status === 200) {
            await Swal.fire({
              title: t('common.success'),
              text: t('app.password_changed'),
              icon: 'success',
              confirmButtonText: t('common.ok')
            })
          }
          else if (res.data.status === 201) {
            await Swal.fire({
              title: t('common.error'),
              text: t('app.old_password_wrong'),
              icon: 'error',
              confirmButtonText: t('common.ok')
            })
          }
          else if (res.data.status === 203) {
            await Swal.fire({
              title: t('common.error'),
              text: t('app.error_try_again'),
              icon: 'error',
              confirmButtonText: t('common.ok')
            })
          }
          else if (res.data.status === 202) {
            await Swal.fire({
              title: t('common.error'),
              text: t('app.same_password'),
              icon: 'error',
              confirmButtonText: t('common.ok')
            })
          }
        });
      }
    }
    else {
      await Swal.fire({
        title: t('common.error'),
        text: t('common.password_mismatch'),
        icon: 'error',
        confirmButtonText: t('common.ok')
      })
    }
  }


  nextstep = async (e, num) => {
    e.preventDefault();
    const { stateregis, phoneNumber, checkboxacc, fname, otpphone, accnumbertxt } = this.state

    console.log(num);
    if (num === 1) {
      const check = await this.forgetotpandregister(6);
      console.log(1, phoneNumber.length, check.checked);
      if (phoneNumber.length === 10 && check.checked) {
        this.setState({
          stateregis: 2
        });
      }
      else {
        if (phoneNumber.length !== 10) {
          this.setState({
            stateopterror: t('common.wrong_phone')
          });
        }
        else if (!check.checked && check.status === 201) {
          this.setState({
            stateopterror: t('common.phone_in_use')
          });
        }
        else {
          this.setState({
            stateopterror: t('common.too_frequent')
          });
        }

        document.getElementById("phoneNumber").style = "border-color: #ef4444;";
        document.getElementById("checkotpforgetphonenormal").style.display = "block";
      }
    }
    else if (num === 2) {

      if (checkboxacc !== 0 && fname !== "" && accnumbertxt !== "") {
        this.setState({
          stateregis: 3
        });
      }
      else {
        await Swal.fire({
          title: t('common.warning'),
          text: t('common.select_bank_or_fill'),
          icon: 'warning',
          confirmButtonText: t('common.ok')
        })
        //////console.log(2, stateregis, checkboxacc);
      }
    }
    else if (num === 3) {
      //////console.log(1, stateregis, num);
      this.setState({
        stateregis: 4
      });
    }
    else if (num === 5) {
      var check = await this.forgetotpandregister(7);
      if (otpphone !== "" && check.checked) {
        this.setState({
          stateregis: 2
        });
      }
      else if (otpphone === "" || otpphone.length < 4) {
        this.setState({
          stateopterror: t('common.otp_incomplete')
        });
        document.getElementById("otpphone").style = "border-color: #ef4444;";
        document.getElementById("checkotp").style.display = "block";
      }

      else {
        this.setState({
          stateopterror: t('common.wrong_code')
        });
        document.getElementById("otpphone").style = "border-color: #ef4444;";
        document.getElementById("checkotp").style.display = "block";
      }



    }
    else if (num === 11) {
      //////console.log(1, stateregis, num);
      this.setState({
        stateregis: 1
      });
    }
    else if (num === 22) {
      //////console.log(1, stateregis, num);
      this.setState({
        stateregis: 2
      });
    }
  }

  forgetotpandregister = async (type) => {
    const { phoneNumber, otpphoneforget, otpphone } = this.state;
    var recheck = false;
    if (type === 4) {
      await instance.post("/api/v1/resetpassword", {
        username: phoneNumber,
        System: Systems,
        type: type
      }).then(async (res) => {
        recheck = res.data.message;
      });
    }
    else if (type === 5) {
      await instance.post("/api/v1/resetpassword", {
        username: phoneNumber,
        pin: otpphoneforget,
        System: Systems,
        type: type
      }).then(async (res) => {
        recheck = res.data.message;

      });
    }
    else if (type === 6) {
      await instance.post("/api/v1/resetpassword", {
        username: phoneNumber,
        System: Systems,
        type: type
      }).then(async (res) => {
        recheck = res.data.message;
      });
    }
    else if (type === 7) {
      await instance.post("/api/v1/resetpassword", {
        username: phoneNumber,
        pin: otpphone,
        System: Systems,
        type: type
      }).then(async (res) => {
        recheck = res.data.message;

      });
    }
    return recheck
  }

  test = async () => {
    await Swal.fire({
      title: t('common.warning'),
      text: t('app.insufficient_withdraw'),
      icon: 'warning',
      confirmButtonText: t('common.ok')
    })
  }

  nextstepforget = async (e, num) => {
    e.preventDefault();
    console.log(num);
    const { phoneNumber, otpphoneforget } = this.state
    if (num === 1) {
      const check = await this.forgetotpandregister(4);
      if (phoneNumber.length === 10 && check.checked) {
        this.setState({
          stateforget: 2
        });
      }
      else {
        if (phoneNumber.length !== 10) {
          this.setState({
            stateopterror: t('common.wrong_phone')
          });
        }
        else if (!check.checked && check.status === 201) {
          this.setState({
            stateopterror: t('app.phone_not_found')
          });
        }
        else {
          this.setState({
            stateopterror: t('common.too_frequent')
          });
        }
        document.getElementById("phoneNumberforget").style = "border-color: #ef4444;";
        document.getElementById("checkotpforgetphone").style.display = "block";
      }
    }
    else if (num === 2) {
      const check = await this.forgetotpandregister(5)
      console.log(check)
      if (otpphoneforget !== "" && check.checked) {
        this.setState({
          stateforget: 3
        });
      }
      else if (otpphoneforget === "" || otpphoneforget.length < 4) {
        this.setState({
          stateopterror: t('common.otp_incomplete')
        });
        document.getElementById("otpphoneforget").style = "border-color: #ef4444;";
        document.getElementById("checkotpforget").style.display = "block";
      }
      else {
        this.setState({
          stateopterror: t('common.wrong_code')
        });
        document.getElementById("otpphoneforget").style = "border-color: #ef4444;";
        document.getElementById("checkotpforget").style.display = "block";
      }

    }
    else if (num === 11) {
      this.setState({
        stateforget: 1
      });
    }
  }

  submitwithdraw = async (e) => {
    //////console.log(this.state.withdrawamount, this.state.balance);
    // [2026-10-26] เดิม fix ไว้ 100 → ใช้ "ถอนขั้นต่ำ" ที่ตั้งใน BO (tblsetting.minwithdraw) · ยังไม่ได้ตั้ง = ปล่อยให้ระบบหลังบ้านเช็ค (ค่าเริ่ม 1)
    const minWd = Number(this.state.minwithdraw) > 0 ? Number(this.state.minwithdraw) : 1;
    if (parseFloat(this.state.withdrawamount) <= parseFloat(this.state.balance)) {
      if (parseFloat(this.state.withdrawamount) >= minWd) {
        var token = localStorage.getItem('auth_token');
        if (token !== null) {
          var decoded = jwt_decode(token);
          var Username = decoded.message.playerid;
          instance.post("/api/v1/userwithdraw", {
            User_id: Username,
            System: Systems,
            amount: this.state.withdrawamount
          }, {
            headers: { Authorization: `Bearer ${token}` }
          }).then(async (res) => {
            if (res.data.status === 200) {
              await Swal.fire({
                title: t('common.success'),
                text: t('app.withdraw_success'),
                icon: 'success',
                confirmButtonText: t('common.ok')
              })
              window.location.reload(false);
            }
            else if (res.data.status === 206) {
              await Swal.fire({
                title: t('common.success'),
                text: t('app.withdraw_bonus_cap').replace('{amount}', res.data.amountturnover),
                icon: 'success',
                confirmButtonText: t('common.ok')
              })
            }
            else if (res.data.status === 203) {
              await Swal.fire({
                title: t('common.error'),
                text: t('app.turnover_remaining').replace('{amount}', res.data.amountturnover),
                icon: 'error',
                confirmButtonText: t('common.ok')
              })
            }
            else {
              // [2026-10-26] สถานะอื่น (เช่น ต่ำกว่าขั้นต่ำ / เกินสูงสุด / ปิดถอน) เดิมเงียบ ไม่แจ้งอะไร → แสดงข้อความจากระบบ
              await Swal.fire({
                title: t('common.warning'),
                text: (res.data && typeof res.data.message === 'string' && res.data.message) || t('app.withdraw_problem'),
                icon: 'warning',
                confirmButtonText: t('common.ok')
              })
            }
          });
        }
        else {
          await Swal.fire({
            title: t('common.error'),
            text: t('app.withdraw_problem'),
            icon: 'error',
            confirmButtonText: t('common.ok')
          })
        }
      }
      else {
        await Swal.fire({
          title: t('common.warning'),
          text: t('app.withdraw_min') + ' ' + minWd,
          icon: 'warning',
          confirmButtonText: t('common.ok')
        })
      }
    }
    else {
      await Swal.fire({
        title: t('common.warning'),
        text: t('app.insufficient_withdraw'),
        icon: 'warning',
        confirmButtonText: t('common.ok')
      })
    }

  }

  onChangex = event => {
    // console.log("event", event.target.name);


    if (event.target !== undefined) {
      let nam;
      let val;
      if (event.target.name === "otpphone") {
        document.getElementById("otpphone").style = "";
        document.getElementById("checkotp").style.display = "none";
      }
      else if (event.target.name === "phoneNumber") {
        document.getElementById("phoneNumberforget").style = "";
        document.getElementById("checkotpforgetphone").style.display = "none";
      }
      else if (event.target.name === "otpphoneforget") {
        document.getElementById("otpphoneforget").style = "";
        document.getElementById("checkotpforget").style.display = "none";
      }
      else if (event.target.name === "otpphoneforget") {
        document.getElementById("phoneNumber").style = "";
        document.getElementById("checkotpforgetphonenormal").style.display = "none";
      }

      if (event.target.name === undefined) {
        nam = event.name;
        val = event.value;
      } else {
        nam = event.target.name;
        val = event.target.value;
      }
      this.setState({ [nam]: val });
    }
  };

  logout = (e) => {
    ////////console.log(e);
    // window.location.href = '/logout';

  }

  openchangepassword = (e) => {
    e.preventDefault();
    const { changepassword } = this.state
    ////////console.log(changepassword);
    if (changepassword)
      this.setState({
        changepassword: false
      });
    else
      this.setState({
        changepassword: true
      });

  }

  cancelwithdraw = async (e, index) => {
    e.preventDefault();
    var token = localStorage.getItem('auth_token');
    if (token !== null) {
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      Swal.fire({
        icon: 'warning',
        title: t('app.confirm_cancel_withdraw'),
        showCancelButton: true,
        confirmButtonText: t('common.confirm'),
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          await instance.post("/api/v1/userwithdrawcancel", {
            User_id: Username,
            tid: index.tid,
            System: Systems,
            amount: index.amount
          }, {
            headers: { Authorization: `Bearer ${token}` }
          }).then(async (res) => {
            if (res.data.status === 200) {
              const datas = res.data.message;
              this.calllisthistory(Username);
              Swal.fire(t('common.done'), '', 'success')
            }
            else {
              Swal.fire(t('common.try_later'), '', 'error')
            }
          });

        }
      })
    }

  }

  cancelredeempromotion = async (e, index) => {
    e.preventDefault();
    var token = localStorage.getItem('auth_token');
    if (token !== null) {
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      Swal.fire({
        icon: 'warning',
        title: t('common.confirm_cancel_promo'),
        showCancelButton: true,
        confirmButtonText: t('common.confirm'),
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          await instance.post("/api/v1/usercancelpromotion", {
            User_id: Username,
            no: index.no,
            System: Systems,
          }, {
            headers: { Authorization: `Bearer ${token}` }
          }).then(async (res) => {
            if (res.data.status === 200) {
              this.checkpro(null, 999);
              Swal.fire(t('common.done'), '', 'success')
            }
            else {
              Swal.fire(t('common.try_later'), '', 'error')
            }
          });

        }
      })
    }

  }
  couponredeem = async (e, index) => {
    e.preventDefault();
    var token = localStorage.getItem('auth_token');
    if (token !== null) {
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      await instance.post("/api/v1/usercoupon", {
        User_id: Username,
        System: Systems,
        couponkey: this.state.couponkey,
        type: 1
      }).then(async (res) => {
        if (res.data.status === 200) {
          const datas = res.data.message;
          await Swal.fire({
            title: t('common.success'),
            text: t('app.coupon_success'),
            icon: 'success',
            confirmButtonText: t('common.ok')
          })
        }
        else {
          await Swal.fire({
            title: t('common.warning'),
            text: t('app.coupon_invalid'),
            icon: 'warning',
            confirmButtonText: t('common.ok')
          })
        }
      });
    }

  }

  async calllisthistory(userid) {
    await instance.post("/api/v1/userwithdrawlist", {
      userid: userid,
      Cat_ID: 0,
      System: Systems,
      page: 1,
      type: 1
    }).then((res) => {
      if (res.data.status === 200) {
        const datas = res.data.message;
        //  //console.log(datas.withdrawlist);
        this.setState({
          historylist: datas.withdrawlist
        });

      }
      else {
        // this.CheckThisGoalError();
      }
    });

  }

  // async saveclick(linkid) {
  //   await instance.post("/api/v1/saveclick", {
  //     linkid: linkid,
  //     System: Systems,
  //   }).then((res) => {
  //   });

  // }
  async saveclickaff(linkid) {
    await instance.post("/api/v1/saveclickaff", {
      linkid: linkid,
      System: Systems,
    }).then((res) => {
      if (res.data.status === 200) {
        var date = new Date()
        this.setState({
          userrecomend: res.data.username,
          link: linkid
        });
        var username = res.data.username
        var object = { date, username }
        localStorage.setItem('aff', JSON.stringify(object))
      }
    }).catch(async (err) => {
    });

  }

  async componentDidMount() {
    //  const endpoint = "https://betner.co:9000";
    const endpoint = "https://apisock.newworld.center";
    const socket = io.connect(endpoint);
    var roomid = Systems;
    var obj = { roomid }
    var json = JSON.stringify(obj);
    socket.on('connect', function (data) {
      var roomid = Systems // [2026-11-03] เดิม hardcode "betner" -> ผู้เล่นเว็บนี้ไปนับเป็นออนไลน์ของ betner ในหลังบ้าน
      var obj = { roomid }
      var json = JSON.stringify(obj);
      socket.emit('new', json);
    });
    const space = window.location.host
    //console.log(space);
    const search = window.location.href;
    var test = search.split("aff=")[1]
    //console.log(test.split("&")[0]);
    if (test !== undefined) {
      this.saveclickaff(test.split("&")[0]);

    }

    var params = search.split("reg=")[1]
    //  console.log(params);
    if (params !== undefined) {
      this.saveclick(params);
      this.setState({
        userrecomend: params.split("&")[0],
      });
    }


    var token = localStorage.getItem('register');
    if (token !== null) {

      var codev = JSON.parse(token)
      console.log(1359, codev);
      var Username = codev.username;

      this.setState({
        userrecomend: Username,
      });
    }


    var tokenx = localStorage.getItem('aff');
    if (tokenx !== null) {
      var codevx = JSON.parse(tokenx)
      console.log(1370, codevx);
      var Usernamex = codevx.username;
      this.setState({
        userrecomend: Usernamex,
      });
    }


    try {

      await instance.post("/api/v1/mainsetting", {
        System: Systems,
      }).then((res) => {
        if (res.data.status === 200) {


          const datas = res.data.message;
          // console.log( datas[7].value)
          var min = res.data.tblcatagoryx[0].limitdeposit;
          var max = res.data.tblcatagoryx[0].maxdeposit;
          var maxwithdrawstatus = res.data.tblcatagoryx[0].withdrawmax
          var limit = { min, max }
          this.setState({
            minwithdraw: Number((res.data.tblsetting && res.data.tblsetting[0] && res.data.tblsetting[0].minwithdraw) ?? res.data.tblcatagoryx[0].minwithdraw) || 0, // [2026-10-26] ถอนขั้นต่ำจากตั้งค่า (BO)
            maxwithdrawstatus: maxwithdrawstatus,
            linelink: datas[1].value,
            webnamex: datas[7].value,
            System: res.data.tblcatagoryx[0].System,
            cashoutSet: res.data.tblcashoutsetting[0],
            inviteSet: res.data.tblinvitedsetting[0],
            datas: datas,
            limit: limit,
          });
        }
        else {
          // this.CheckThisGoalError();
        }
      });
    }
    catch (ex) {
      console.log(ex);
    }

    await this.checklogin();
    if (!this.state.checkboxcookie) {
      // setTimeout(function () {
      //   document.getElementById("openpopup").click()
      // }, 500);
    }

    //await this.getwheel();    
    //await this.getcheckin();
    await this.getpopup();
  }

  onChange = async event => {

    if (event.target !== undefined) {
      let nam;
      let val;
      if (event.target.name === undefined) {
        nam = event.name;
        val = event.value;
      } else {
        nam = event.target.name;
        val = event.target.value;
      }
      if (nam === "withdrawamount") {

        if (this.state.maxwithdrawstatus === 1) {

          this.setState({ [nam]: this.state.balance });
          await Swal.fire({
            title: t('common.warning'),
            text: t('app.force_withdraw_all'),
            icon: 'warning',
            confirmButtonText: t('common.ok')
          })
        }
        else if (Number(val) <= Number(this.state.balance)) {
          this.setState({ [nam]: val });
        }
        else {
          await Swal.fire({
            title: t('common.warning'),
            text: t('app.insufficient_withdraw'),
            icon: 'warning',
            confirmButtonText: t('common.ok')
          })
        }
      } else {
        this.setState({ [nam]: val });
      }

    }
  };

  async checkuseradvice() {
    instance.post("/api/v1/checkuseradvice", {
      User_id: this.state.username,
      page: 1,
      System: Systems,
    }).then((res) => {
      if (res.data.status === 200) {
        console.log(res.data.message.useradvicelist);
        this.setState({
          useradvice: res.data.message.useradvicelist
        });
      }
      else {
        // console.log(res.data);
        // this.CheckThisGoalError();
      }
    });
  }

  closemodal = async (e) => {

    console.log(1159, this.state.checkboxcookie);
    if (this.state.checkboxcookie) {
      var date = new Date()
      var checked = this.state.checkboxcookie
      var object = { date, checked }
      console.log(object);
      localStorage.setItem('cookie', JSON.stringify(object))
    }
  }

  async recheckbox() {
    var checked = false;
    if (this.state.checkboxcookie) checked = false;
    else checked = true;
    this.setState({
      checkboxcookie: checked,
    });

  }

  async checklogin() {

    var token = localStorage.getItem('auth_token');
    //console.log(token);
    if (token !== null) {
      var cookie = localStorage.getItem('cookie');
      console.log(1188, cookie);
      if (cookie !== 'null' && cookie !== null) {
        var persons = JSON.parse(cookie);
        if (persons.checked !== null) {
          this.setState({

            checkboxcookie: persons.checked,
          });
        }
      }

      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      // console.log(33);
      await this.rechecklogin(Username, token);
    }
    else {
      this.setState({
        loginstate: false,
      });
    }
  }

  redeem = (e) => {
    e.preventDefault();
    //this.checklogin();
    console.log('tag', this.state.loginstate);
    if (!this.state.loginstate) {
      var title = 'error'
      var text = t('common.not_logged_in')
      var object = { title, text }
      this.modalerror(object);
    }
    else {
      window.location.href = '/promotions';
    }
  }

  redeemlink = (e, link) => {
    e.preventDefault();
    //this.checklogin();
    console.log('tag', this.state.loginstate);
    if (!this.state.loginstate) {
      var title = 'error'
      var text = t('common.not_logged_in')
      var object = { title, text }
      this.modalerror(object);
    }
    else {
      window.location.href = link;
    }
  }


  async modalerror(object) {
    await Swal.fire({
      title: object.title + "!",
      text: object.text,
      icon: object.title,
      confirmButtonText: t('common.ok')
    })
  }
  validatergisterForm = async (e) => {
    e.preventDefault();
    const { phoneNumber, fname, password, passwordcf, checkboxacc, accnumbertxt } = this.state;

    //////console.log(checkboxacc);
    //////////console.log(this.state)
    if (password.length < 6) {
      ////////console.log(password);
      var title = 'Error!'
      var text = t('app.password_too_short')
      var object = { title, text }
      this.modalerror(object);
      // this.CheckThisGoalError(object);
    }

    else if (phoneNumber === "") {

      title = 'Error!'
      text = t('common.missing_phone')
      object = { title, text }
      this.modalerror(object);

    }
    else if (accnumbertxt === "") {
      title = 'Error!'
      text = t('common.missing_account_no')
      object = { title, text }
      this.modalerror(object);

    }
    else if (fname === "") {

      title = 'Error!'
      text = t('common.missing_name')
      object = { title, text }
      this.modalerror(object);

    }
    else if (checkboxacc === 0) {
      title = 'Error!'
      text = t('common.no_bank_selected')
      object = { title, text }
      this.modalerror(object);
    }
    else if (password !== passwordcf) {
      title = 'Error!'
      text = t('common.password_mismatch')
      object = { title, text }
      this.modalerror(object);
    }

    else {
      instance.post("/api/v1/register", {
        User_id: phoneNumber,
        name: fname,
        password: password,
        accbank: checkboxacc,
        accno: accnumbertxt,
        System: Systems,
        Useradvise: this.state.userrecomend
      })
        .then(async (res) => {
          if (res.data.status === 200) {
            await Swal.fire({
              title: t('common.success'),
              text: t('app.register_success_relogin'),
              icon: 'success',
              confirmButtonText: t('common.ok')
            })
            window.location.href = '/';
          }
          else if (res.data.status === 202) {
            this.setState({
              errorstatus: 1,
              errortext: t('common.username_taken')
            });
          }
          else {
            this.setState({
              errorstatus: 1,
              errortext: t('common.invalid_register_name')
            });
          }
        });
    }


  }
  // async rechecklogin(Username, token) {
  //   try {
  //     // console.log(this.state.System);
  //     //console.log(3);
  //     const linkaff = this.state.webname + "/register?affuser=" + Username;
  //     await instance.post("/api/v1/checkpoint", {
  //       userid: Username,
  //       System: Systems,
  //       Function: 'rechecklogin-App.js'
  //     }, {
  //       headers: { Authorization: `Bearer ${token}` }
  //     }).then(async (res) => {
  //       // //console.log(res.data);
  //       if (res.data.status === 200) {
  //         this.calllisthistory(Username);
  //         //console.log(443, res.data);
  //         localStorage.setItem('auth_token', res.data.token)
  //         var rankall = res.data.tblrankall;
  //         const found = rankall.find(obj => {
  //           return obj.checked === 1;
  //         });
  //         this.setState({
  //           tblrankall: res.data.tblrankall,
  //           linkaff: linkaff,
  //           buttoncliam: (found === undefined) ? true : false,
  //           tblnextrank: res.data.tblnextrank,
  //           rankpic: res.data.tblrank.image,
  //           rankname: res.data.tblrank.name,
  //           rankob: res.data.tblrank,
  //           tblprofile: res.data.message,
  //           rankpoint: res.data.rankpoint,
  //           accnumber: res.data.message.accnumber,
  //           userid: res.data.message.member_id,
  //           username: res.data.message.playerid,
  //           fullname: res.data.message.firstname,
  //           point: res.data.message.Point,
  //           balance: res.data.databalance,
  //           loginstate: true,
  //         });
  //       }
  //       else if (res.data.status === 401) {
  //         localStorage.clear();
  //         await Swal.fire({
  //           title: 'Warning!',
  //           text: 'သင့်စက်ရှင် သက်တမ်းကုန်သွားပါပြီ။ ကျေးဇူးပြု၍ ထပ်မံဝင်ရောက်ပါ။',
  //           icon: 'warning',
  //           confirmButtonText: 'သဘောတူသည်။'
  //         })
  //         window.location.href = '/';
  //       }

  //     }).catch(async (err) => {
  //       // console.log(err);
  //       if (err.response.status === 401 || err.response.status === 403) {
  //         localStorage.clear();
  //         await Swal.fire({
  //           title: 'Warning!',
  //           text: 'သင့်စက်ရှင် သက်တမ်းကုန်သွားပါပြီ။ ကျေးဇူးပြု၍ ထပ်မံဝင်ရောက်ပါ။',
  //           icon: 'warning',
  //           confirmButtonText: 'သဘောတူသည်။'
  //         })
  //         window.location.href = '/';
  //       }
  //     });
  //   }
  //   catch (ex) {
  //     ////////console.log(ex);
  //   }

  // }

  rechecklogin = async (Username, token) => {
    try {

      //const { webnamex } = this.state
      console.log(1406, Username);
      //console.log(3);
      const search = window.location.href;
      const paramx = new URLSearchParams(search);
      // const space = search.split("/")
      const space = window.location.host
      var userhash = md5(Username);
      //  const linkaff = "https://pgline88.com/?register=" + userhash;
      const linkaff = "https://" + space + "/register?reg=" + userhash;
      await instance.post("/api/v1/checkpoint", {
        userid: Username,
        System: Systems,
        Update: userhash,
        Function: 'rechecklogin-App.js'
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(async (res) => {
        console.log(1751, res.data);
        if (res.data.status === 200) {


          this.calllisthistory(Username);
          console.log(443, res.data);
          localStorage.setItem('auth_token', res.data.token)
          var rankall = res.data.tblrankall;
          const found = rankall.find(obj => {
            return obj.checked === 1;
          });

          this.setState({
            tblrankall: res.data.tblrankall,
            linkaff: linkaff,
            buttoncliam: (found === undefined) ? true : false,
            tblnextrank: res.data.tblnextrank,
            rankpic: (res.data.tblrank.image === null || res.data.tblrank.image === "") ? "https://apiclient.newworld.center/build/rank/1.jpeg" : (res.data.tblrank.picrack === null || res.data.tblrank.picrack === "") ? "https://apiclient.newworld.center/build/rank/" + res.data.tblrank.image : res.data.tblrank.picrack,
            rankname: res.data.tblrank.name,
            rankob: res.data.tblrank,
            tblprofile: res.data.message,
            rankpoint: res.data.rankpoint,
            accnumber: res.data.message.accnumber,
            userid: res.data.message.member_id,
            username: res.data.message.playerid,
            fullname: res.data.message.firstname,
            point: res.data.message.Point,
            balance: res.data.databalance,
            loginstate: true,
          });
        }
        else if (res.data.status === 401) {
          localStorage.clear();
          await Swal.fire({
            title: t('common.warning'),
            text: t('common.session_expired'),
            icon: 'warning',
            confirmButtonText: t('common.ok')
          })
          window.location.href = '/';
        }

      }).catch(async (err) => {
        // console.log(err);
        if (err.response.status === 401 || err.response.status === 403) {
          localStorage.clear();
          await Swal.fire({
            title: t('common.warning'),
            text: t('common.session_expired'),
            icon: 'warning',
            confirmButtonText: t('common.ok')
          })
          window.location.href = '/';
        }
      });
    }
    catch (ex) {
      ////////console.log(ex);
    }

  }


  render() {
    //////////console.log(this.state)this.state.userrecomend
    const { cashoutSet, stateopterror, changepassword, username, balance, accnumber, fullname, mainacc, limit, rankob, rankpoint, tblnextrank, userrecomend, linkaff, tblprofile, proderedeem, proderedeemlist, prodetail } = this.state


    // console.log(proderedeem)
    var accnumberx;
    var limits = limit
    if (accnumber !== null) {
      // ////////console.log(accnumber[0].accno);
      accnumberx = accnumber[0];
    }

    return (
      <div className="-full-flex-wrap ">
        {/* </div> <div className="-full-flex-inner-bg -bg"> */}
        <BrowserRouter >

          <Routes>
            {siteRoutes()}
            <Route path="/*" element={<Main />} />
            <Route path="/register/*" element={
              <div className="rp-register-page">
                <div className="rp-register-card">
                  <RegisterForm />
                </div>
              </div>
            } />
            {/* <Route path="/casino" element={<Casino />} />
            <Route path="/slot" element={<Slot />} />
            <Route path="/sport" element={<Sport />} />
            <Route path="/arcade" element={<Arcade />} />
            <Route path="/fising" element={<Fising />} />
            <Route path="/promotions" element={<Promotion />} />
            <Route path="/lotto" element={<Freegame />} />
            <Route path="/listgameall/*" element={<Linklistall />} />
            <Route path="/listgamealldemo/*" element={<Linklistalldemo />} />
            <Route path="/logout" element={<Logout />} />
          
            <Route path='/Paoyingchub' element={<Promotion />} /> */}
          </Routes>
        </BrowserRouter>

        {/* หน้าเลือกโปรก่อนเติม */}
    
        {/* หน้าเลือกโปรก่อนเติม */}
        {/* เติมเงิน */}
   
 
        {/* เติมเงิน */}
        {/* หน้าถอนเงิน */}
  
        {/* หน้าถอนเงิน */}
 
   

    
        {/* หน้าข้อมูลบัญชี */}
   
        {/* หน้าข้อมูลบัญชี */}



     
        {/* รายละเอียดโปร */}
     
        {/* รายละเอียดโปร */}
        {/* Alert */}
   
        {/* Alert */}
        {/* Alert List */}
     
        {/* Alert List */}
        {/* เลือกโปรก่อนเล่นเกม */}
    
        {/* เลือกโปรก่อนเล่นเกม */}
    
      </div >
    );
  }
}

export default App;
